import React from 'react'
import { intl } from 'lang/intl'
import { partial } from 'lodash-es'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form/dist/redux-form'

import { TtIconButton } from '@23/ui-react'

import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { WebinarPanelComponent } from '../../features/WebinarSidebarFeature/components'
import ReduxFormSimpleFieldComponent from '../ReduxFormSimpleFieldComponent/ReduxFormSimpleFieldComponent'
import { reduxFormValidators } from '../../utils'

import './CommentsFormComponent.scss'

const { required } = reduxFormValidators

const handleKeyDown = (handleSubmit, e) => {
  if (e.keyCode === 13 && e.shiftKey === false) {
    handleSubmit(e)
  }
}

const getSubmitPromise = (onSubmit, values) =>
  new Promise((resolve, reject) => {
    onSubmit(values, { resolve, reject })
  })

const CommentsFormComponent = ({
  invalid,
  submitting,
  pristine,
  onSubmit,
  handleSubmit,
}) => {
  const isButtonDisabled = invalid || submitting || pristine
  const handleFormSubmit = handleSubmit(partial(getSubmitPromise, onSubmit))
  const { tabs } = useWebinarColors()

  const styles = {
    '--chat-form-input-text-color': tabs.highContrast.color,
    '--chat-form-input-placeholder-color': tabs.highContrast.transparent('50%'),
    '--chat-form-input-placeholder-color-disabled':
      tabs.highContrast.transparent('20%'),
    '--chat-form-button-color': tabs.contrast.transparent('87%'),
    '--chat-form-button-color-disabled': tabs.contrast.transparent('20%'),
  }

  return (
    <div className="question-form-component">
      <form
        className="questions-form"
        onSubmit={handleFormSubmit}
        style={styles}
      >
        <WebinarPanelComponent>
          <Field
            name="content"
            component={ReduxFormSimpleFieldComponent}
            type="text"
            className="message field-component"
            placeholder={intl.formatMessage({
              defaultMessage: 'Ask a question to the speakers',
            })}
            validate={required}
            forceHideError
            customInputProps={{
              autoComplete: 'off',
              onKeyDown: partial(handleKeyDown, handleFormSubmit),
            }}
          />
          <TtIconButton
            name="send"
            label={intl.formatMessage({
              defaultMessage: 'Ask a question to the speakers',
            })}
            type="submit"
            disabled={isButtonDisabled}
          />
        </WebinarPanelComponent>
      </form>
    </div>
  )
}

CommentsFormComponent.propTypes = {
  onSubmit: PropTypes.func,
  pristine: PropTypes.bool,
  // redux-form props
  invalid: PropTypes.bool,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
}

export default reduxForm()(CommentsFormComponent)
